$(function () {
    $(".panel-drawer__label").on("click", function () {
        if ($(this).closest("li").hasClass("active")) {
            $(this).closest("li").removeClass("active");
            $(this).filter("[aria-expanded]").attr("aria-expanded", "false");
            return false;
        }

        $(this).closest(".panel-drawers").find(".panel-drawer").removeClass("active")
            .find(".panel-drawer__label[aria-expanded]").attr("aria-expanded", "false");
        $(this).closest("li").addClass("active");
        $(this).filter("[aria-expanded]").attr("aria-expanded", "true");
    });
})